module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-11-eb00cd67c97a33d2582eee789c66bf30.jpg";